import { Box, Typography, useTheme } from "@mui/material";

interface IForubusSignatureSectionProps {
  title: string;
  icon?: React.ReactNode;
  children: React.ReactNode;
}

export const ForubusSignatureSection: React.FC<
  IForubusSignatureSectionProps
> = ({ title, icon, children }) => {
  const theme = useTheme();
  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 0.75,
          px: 1,
          pb: 0.5,
          mb: 0.25,
        }}
      >
        {icon && (
          <Box
            sx={{
              color: theme.palette.text.disabled,
              display: "flex",
              fontSize: 14,
            }}
          >
            {icon}
          </Box>
        )}
        <Typography
          variant="overline"
          sx={{
            color: theme.palette.text.disabled,
            letterSpacing: "0.1em",
            fontSize: "0.62rem",
            lineHeight: 1,
          }}
        >
          {title}
        </Typography>
      </Box>
      <Box>{children}</Box>
    </Box>
  );
};
